const ONBOARDING_USER_KEY = 'sf-onboarding-user';
const PLATFORM_ONBOARDING_KEY = 'sf-platform-onboarded';
const PLATFORM_ACTIVATION_DISMISS_KEY = 'sf-platform-activation-dismissed';

export const markUserForOnboarding = (userId: string) => {
  try {
    localStorage.setItem(ONBOARDING_USER_KEY, userId);
  } catch (error) {
    console.warn('Unable to persist onboarding state', error);
  }
};

export const consumeUserOnboarding = (userId?: string | null) => {
  if (!userId) {
    return false;
  }

  try {
    const stored = localStorage.getItem(ONBOARDING_USER_KEY);
    if (stored && stored === userId) {
      localStorage.removeItem(ONBOARDING_USER_KEY);
      return true;
    }
  } catch (error) {
    console.warn('Unable to read onboarding state', error);
  }
  return false;
};

export const clearUserOnboarding = (userId?: string | null) => {
  if (!userId) {
    return;
  }

  try {
    const stored = localStorage.getItem(ONBOARDING_USER_KEY);
    if (stored && stored === userId) {
      localStorage.removeItem(ONBOARDING_USER_KEY);
    }
  } catch (error) {
    console.warn('Unable to clear onboarding state', error);
  }
};

const readPlatformMap = (): Record<string, string> => {
  try {
    const raw = localStorage.getItem(PLATFORM_ONBOARDING_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') {
        return parsed as Record<string, string>;
      }
    }
  } catch (error) {
    console.warn('Unable to read platform onboarding map', error);
  }
  return {};
};

const readPlatformActivationDismissals = (): Record<string, string> => {
  try {
    const raw = localStorage.getItem(PLATFORM_ACTIVATION_DISMISS_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') {
        return parsed as Record<string, string>;
      }
    }
  } catch (error) {
    console.warn('Unable to read platform activation dismissal map', error);
  }
  return {};
};

export const hasCompletedPlatformOnboarding = (userId?: string | null): boolean => {
  if (!userId) {
    return false;
  }
  const map = readPlatformMap();
  return Boolean(map[userId]);
};

export const markPlatformOnboardingComplete = (userId?: string | null) => {
  if (!userId) {
    return;
  }
  clearUserOnboarding(userId);

  const map = readPlatformMap();
  map[userId] = new Date().toISOString();
  try {
    localStorage.setItem(PLATFORM_ONBOARDING_KEY, JSON.stringify(map));
  } catch (error) {
    console.warn('Unable to persist platform onboarding map', error);
  }

  clearPlatformActivationDismissal(userId);
};

export const hasDismissedPlatformActivation = (userId?: string | null): boolean => {
  if (!userId) {
    return false;
  }

  const map = readPlatformActivationDismissals();
  return Boolean(map[userId]);
};

export const dismissPlatformActivation = (userId?: string | null) => {
  if (!userId) {
    return;
  }
  clearUserOnboarding(userId);

  const map = readPlatformActivationDismissals();
  map[userId] = new Date().toISOString();
  try {
    localStorage.setItem(PLATFORM_ACTIVATION_DISMISS_KEY, JSON.stringify(map));
  } catch (error) {
    console.warn('Unable to persist platform activation dismissal map', error);
  }
};

export const clearPlatformActivationDismissal = (userId?: string | null) => {
  if (!userId) {
    return;
  }

  const map = readPlatformActivationDismissals();
  if (!map[userId]) {
    return;
  }

  delete map[userId];
  try {
    localStorage.setItem(PLATFORM_ACTIVATION_DISMISS_KEY, JSON.stringify(map));
  } catch (error) {
    console.warn('Unable to clear platform activation dismissal map', error);
  }
};
